import { useMutation } from '@tanstack/react-query';
import { searchService } from '../../../../api';

// iOS: MetaInputEntryMarketReactor / Android: InputNonEntryMarketViewModel
export const usePostNonEntryMarkets = () => {
  return useMutation({
    mutationFn: searchService.postNonEntryMarkets,
    throwOnError: false,
  });
};
